<template>
    <div class="recharge-content" >
        <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="充值金额" class="recharge-money">
                <el-input v-model="form.money" placeholder="请输入充值金额(元)"></el-input>
            </el-form-item>
            <div class="recharge-num">充值度数：{{(form.money * device.Price).toFixed(2)}}</div>
            <el-form-item label="充值原因">
                <el-input type="textarea" v-model="form.reason"></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import store from "../store";

    export default {
        name: "Recharge",
        data() {
            return {
                dialogVisible: true,
                form: {
                    money: 0,
                    reason: '',
                },
                price: 0,
            }
        },
        mounted() {
            console.log('fs')
        },
        methods: {
            confirmRecharge(devid) {
                let value = this.form.money,
                    reason = this.form.reason;
                this.$http({
                    method: 'put',
                    url: `${store.state.url}account/recharge/${devid}/${value}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`,
                    data: {reason: reason}
                })
                    .then((res) => {
                        if (res.Code == 0) {
                            this.$message(res.Message);
                        } else {
                            this.$message(res.Message);
                        }
                    })
            }
        },
        computed: {
            device() {
                return store.state.rechargeDevice;
            },
            status() {
                return store.state.rechargeConfirm;
            }
        },
        watch: {
            status(val, oldVal) {
                this.confirmRecharge(this.device.Devid);
            },
        }
    }
</script>

<style scoped>
    .recharge-money {
        margin-bottom: 0.05rem;
    }
    .recharge-num {
        padding-left: 0.8rem;
        margin-bottom: 0.1rem;
    }
</style>